<!-- <app-notification-banner></app-notification-banner> -->
<app-install-prompt></app-install-prompt>
<router-outlet></router-outlet>
<app-modals></app-modals>
<app-tour-overlay></app-tour-overlay>